var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4225_18546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5028 4.44548C11.5028 2.91214 12.7528 1.66798 14.2928 1.66798C14.6584 1.6671 15.0207 1.73825 15.3588 1.87736C15.6969 2.01646 16.0043 2.22081 16.2635 2.47872C16.5226 2.73664 16.7285 3.04307 16.8692 3.38053C17.0099 3.71798 17.0828 4.07985 17.0837 4.44548C17.0837 5.97964 15.8337 7.22381 14.2928 7.22381C13.9233 7.22427 13.5574 7.15127 13.2163 7.00907C12.8753 6.86687 12.5659 6.6583 12.3062 6.39548L8.44366 9.02548C8.55123 9.56131 8.49848 10.117 8.29199 10.623L12.527 13.4063C13.0258 12.9995 13.65 12.7778 14.2937 12.7788C14.6593 12.778 15.0215 12.8493 15.3596 12.9885C15.6976 13.1277 16.005 13.3322 16.2641 13.5901C16.5231 13.8481 16.7289 14.1546 16.8695 14.4921C17.0101 14.8296 17.0829 15.1915 17.0837 15.5571C17.0837 17.0905 15.8337 18.3346 14.2928 18.3346C13.5546 18.3362 12.8459 18.0445 12.3227 17.5236C11.7995 17.0027 11.5046 16.2954 11.5028 15.5571C11.5022 15.1677 11.5843 14.7825 11.7437 14.4271L7.54199 11.668C7.03317 12.1104 6.38126 12.3535 5.70699 12.3521C5.34134 12.353 4.9791 12.2818 4.64096 12.1427C4.30283 12.0035 3.99543 11.7991 3.73634 11.5411C3.47724 11.283 3.27152 10.9765 3.13093 10.639C2.99035 10.3014 2.91765 9.93946 2.91699 9.57381C2.91776 9.20823 2.99054 8.84638 3.13117 8.50893C3.27181 8.17147 3.47754 7.86503 3.73663 7.60711C3.99572 7.34918 4.30308 7.14482 4.64116 7.00571C4.97924 6.86659 5.34141 6.79543 5.70699 6.79631C6.59366 6.79631 7.38199 7.20714 7.89283 7.84714L11.637 5.29798C11.5479 5.02259 11.5026 4.73492 11.5028 4.44548Z",
    fill: "#8898A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4225_18546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.414e11aad894dd24fe3e615ccf150bc1.svg";
export { ForwardRef as ReactComponent };